<div class="form-control">  
    
    <div class="flex items-center gap-2">
      <input
        [class.invalid]="control.invalid && control.dirty && control.touched"
        [formControl]="control"
        type="checkbox"
        [id]="inputId"
        [name]="inputId"
        class="h-4 w-4">
      <ng-container *ngIf="label">
        <label [for]="inputId" class="uppercase font-bold text-[14px]/[14px]">
          {{ label }}
        </label>
      </ng-container>
    </div>
    <ng-container *ngIf="control.invalid && control.dirty && control.touched">
      <div *ngFor="let err of control.errors | keyvalue" class="mt-2 font-bold text-[14px]/[14px]" style="color: red;">
        {{ errorMessages[err.key] ? errorMessages[err.key] : 'Hay un error en este campo' }}
      </div>
    </ng-container>
  </div>

  